export { default } from './StaticDatePicker'
